/**
 *
 * PluginIcon
 *
 */

import React from 'react';
const PluginIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "19",
  height: "15",
  viewBox: "0 0 19 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "none",
  d: "M17.2727 0.431818C16.3141 0.129545 15.2605 0 14.25 0C12.5659 0 10.7523 0.345455 9.5 1.29545C8.24773 0.345455 6.43409 0 4.75 0C3.06591 0 1.25227 0.345455 0 1.29545V13.9477C0 14.1636 0.215909 14.3795 0.431818 14.3795C0.475 14.3795 0.507386 14.3687 0.539773 14.358C0.572159 14.3472 0.604545 14.3364 0.647727 14.3364C1.81364 13.775 3.49773 13.3864 4.75 13.3864C6.43409 13.3864 8.24773 13.7318 9.5 14.6818C10.6659 13.9477 12.7818 13.3864 14.25 13.3864C15.675 13.3864 17.1432 13.6455 18.3523 14.2932C18.4386 14.3364 18.4818 14.3364 18.5682 14.3364C18.7841 14.3364 19 14.1205 19 13.9045V1.29545C18.4818 0.906818 17.9205 0.647727 17.2727 0.431818ZM17.2727 12.0909C16.3227 11.7886 15.2864 11.6591 14.25 11.6591C12.7818 11.6591 10.6659 12.2205 9.5 12.9545V3.02273C10.6659 2.28864 12.7818 1.72727 14.25 1.72727C15.2864 1.72727 16.3227 1.85682 17.2727 2.15909V12.0909ZM6.02864 8.47781H4.19679L3.85268 9.5H2.76639L4.54089 4.52734H5.7149L7.4759 9.5H6.34913L6.02864 8.47781ZM5.73851 7.62092L5.11777 5.66424L4.47679 7.62092H5.73851ZM11.4027 9.5H15.2722V8.62287H12.6644L15.2654 5.36062V4.52734H11.4668V5.40785H13.97L11.4027 8.62287V9.5Z"
}));
export default PluginIcon;